/* Routes custom add-to-cart forms into the cart drawer (was inline in layout/theme.liquid). */
  (() => {
    if (window.oakCollectionCartDrawerBound) return;
    window.oakCollectionCartDrawerBound = true;

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.custom-collection-form, .scps-add-form, .ctps-add-form, .cro-mobile-product-form, .cro-desktop-form, [data-watch-buy-form]');
      const drawer = document.querySelector('cart-drawer');
      if (!form || !drawer || typeof drawer.renderContents !== 'function') return;
      // Buy Now buttons (formaction with return_to) keep their normal redirect,
      // except the product page's own Buy Now, which opens the cart drawer like Add to bag.
      if (event.submitter && event.submitter.hasAttribute('formaction') && !event.submitter.matches('[data-cro-buy-button], [data-cro-desktop-buy-button]')) return;

      event.preventDefault();
      // Product page Add to bag (mobile + desktop): add to the cart drawer but stay on the page.
      const stayOnPage = !!(event.submitter && event.submitter.matches('[data-cro-add-button], [data-cro-desktop-add-button]'));
      const button = stayOnPage ? event.submitter : form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      let added = false;

      const formData = new FormData(form);
      formData.append('sections', drawer.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
      drawer.setActiveElement(document.activeElement);

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        });
        const cartData = await response.json();
        if (!response.ok || cartData.status) throw new Error(cartData.description || 'Unable to add item');
        drawer.renderContents(cartData, stayOnPage ? { open: false } : undefined);
        added = true;
      } catch (error) {
        console.error(error);
      } finally {
        if (button) button.disabled = false;
        if (stayOnPage && added && button) {
          const label = button.textContent;
          button.textContent = 'Added ✓';
          setTimeout(() => {
            if (button.textContent === 'Added ✓') button.textContent = label;
          }, 1500);
        }
      }
    }, true);
  })();
